import { PersistStorage, StorageValue } from "zustand/middleware/persist";
import CryptoJS from 'crypto-js';

const hashCode = process.env.NEXT_PUBLIC_HASH_CODE;
if (!hashCode) {
  throw new Error("NEXT_PUBLIC_HASH_CODE environment variable is not set");
}

export interface MigrationOptions<T> {
  isLegacyData: (data: any) => boolean;
  migrateLegacyData: (data: any) => T;
}

/**
 * 建立加密的儲存處理器
 * @param migrationOptions 處理舊資料格式的選項（可選）
 * @returns PersistStorage 物件
 */
export const createEncryptedStorage = <T>(migrationOptions?: MigrationOptions<T>): PersistStorage<T> => ({
  getItem: (key: string): Promise<StorageValue<T> | null> => {
    const encrypted = localStorage.getItem(key);
    if (!encrypted) return Promise.resolve(null);

    try {
      // 如果有提供轉換選項且資料是舊格式，進行轉換
      if (migrationOptions && migrationOptions.isLegacyData(encrypted)) {
        const migrated = migrationOptions.migrateLegacyData(encrypted);

        // 這裡 version 設為 0，如有變更數字需要在 Store 中處理 Migration
        const migratedValue = { state: migrated, version: 0 };

        // 將轉換後的資料加密並儲存到 localStorage
        const newEncrypted = CryptoJS.AES.encrypt(JSON.stringify(migratedValue), hashCode).toString();
        localStorage.setItem(key, newEncrypted);

        return Promise.resolve(migratedValue);
      }

      const bytes = CryptoJS.AES.decrypt(encrypted, hashCode);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      if (!decrypted) return Promise.resolve(null);

      const data = JSON.parse(decrypted);
      return Promise.resolve(data);
    } catch (error) {
      return Promise.resolve(null);
    }
  },
  setItem: (key: string, value: StorageValue<T>): void => {
    try {
      const encrypted = CryptoJS.AES.encrypt(JSON.stringify(value), hashCode).toString();
      localStorage.setItem(key, encrypted);
    } catch (error) {

    }
  },
  removeItem: (key: string): void => {
    localStorage.removeItem(key);
  },
});
